import { PageFrame } from "../../components/page_frame";
import { InventoryHealthContainer } from "./container";

export default function InventoryHealthMRPPage() {
  return (
    <PageFrame>
      <InventoryHealthContainer />
    </PageFrame>
  );
}
